import React from 'react';

/**
 * VideoOffIcon - holito brand-tier video-camera (camcorder) icon with a slash,
 * for the camera-off state. 2px stroke, 24 grid, round joins, the notch where
 * applicable. Geometry from the brand guide (docs/DESIGN.md section 08 /
 * Iconography).
 */
export const VideoOffIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    {/* Camera body */}
    <path d="M5 7 H12 A3 3 0 0 1 15 10 V14 A3 3 0 0 1 12 17 H5 A3 3 0 0 1 2 14 V10 A3 3 0 0 1 5 7 Z" />
    {/* Lens cone */}
    <path d="M15 12 L21 8 V16 Z" />
    {/* Off slash */}
    <path d="M4 4 L20 20" />
  </svg>
);
